import type { Comic } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <article className="group flex flex-col rounded-lg bg-background-900/70 overflow-hidden border border-background-800/70 hover:border-primary-600/60 transition-colors duration-300">
      <div className="relative overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}韩漫免费看全集封面`}
          title={`${comic.title} - 韩漫免费无删减下拉阅读`}
          className="w-full aspect-[3/4] object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 rounded-md bg-background-950/80 backdrop-blur px-2 py-0.5 text-xs text-secondary-300 flex items-center gap-1">
          <i className="ri-heart-3-fill text-accent-500" />
          {comic.rating}
        </span>
        <span className="absolute top-2 right-2 rounded-md bg-primary-600/90 px-2 py-0.5 text-xs text-background-950 font-medium">
          {comic.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/90 to-transparent p-3">
          <p className="text-xs text-foreground-100 line-clamp-2 leading-relaxed">
            {comic.description}
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-2 p-3 md:p-4">
        <h4 className="font-heading text-base font-bold text-foreground-50 truncate">
          {comic.title}
        </h4>
        <div className="flex items-center gap-2 text-xs text-foreground-400">
          <span className="rounded-md bg-secondary-500/15 text-secondary-300 px-2 py-0.5">
            {comic.category}
          </span>
          <span className="truncate">共{comic.chapters}话</span>
          <span className="ml-auto flex items-center gap-1">
            <i className="ri-eye-line" />
            {comic.views}
          </span>
        </div>
        <a
          href="#featured"
          className="mt-1 inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-background-800 hover:bg-primary-600 text-foreground-100 hover:text-background-950 px-3 py-1.5 text-sm font-medium transition-colors cursor-pointer"
        >
          立即阅读
          <i className="ri-arrow-right-line text-base" />
        </a>
      </div>
    </article>
  );
}